// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme from "./styles/Theme.bs.js";
import * as Button from "./components/Button/Button.bs.js";
import * as Emotion from "./bindings/Emotion.bs.js";
import * as HomePage from "./pages/HomePage.bs.js";
import * as PostPage from "./pages/PostPage.bs.js";
import * as AboutPage from "./pages/AboutPage.bs.js";
import * as LoginPage from "./pages/LoginPage.bs.js";
import * as PostsPage from "./pages/PostsPage.bs.js";
import * as Typography from "./components/Typography/Typography.bs.js";
import * as JournalPage from "./pages/JournalPage.bs.js";
import * as CallbackPage from "./pages/CallbackPage.bs.js";
import * as ComponentsPage from "./pages/ComponentsPage.bs.js";
import * as ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";

function Router$NotFound(props) {
  let containerStyles = Emotion.Css.css({
    padding: "4rem 1rem",
    maxWidth: "600px",
    margin: "0 auto",
    textAlign: "center"
  });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Typography.Typography.Display.make, {
        size: "4xl",
        children: "404"
      }),
      JsxRuntime.jsx(Typography.Typography.Body.make, {
        className: Emotion.Css.css({
          marginTop: "1rem",
          color: Theme.Theme.Colors.text.secondary
        }),
        children: "Page not found."
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Button.Button.make, {
          variant: "primary",
          onClick: _evt => RescriptReactRouter.push("/"),
          children: "Go Home"
        }),
        className: Emotion.Css.css({
          marginTop: "2rem"
        })
      })
    ],
    className: containerStyles
  });
}

let NotFound = {
  make: Router$NotFound
};

function Router(props) {
  let url = RescriptReactRouter.useUrl(undefined, undefined);
  let match = url.path;
  if (match === 0) {
    return JsxRuntime.jsx(HomePage.make, {});
  }
  switch (match.hd) {
    case "about" :
      if (match.tl !== 0) {
        return JsxRuntime.jsx(Router$NotFound, {});
      } else {
        return JsxRuntime.jsx(AboutPage.make, {});
      }
    case "callback" :
      if (match.tl !== 0) {
        return JsxRuntime.jsx(Router$NotFound, {});
      } else {
        return JsxRuntime.jsx(CallbackPage.make, {});
      }
    case "components" :
      if (match.tl !== 0) {
        return JsxRuntime.jsx(Router$NotFound, {});
      } else {
        return JsxRuntime.jsx(ComponentsPage.make, {});
      }
    case "journal" :
      let match$1 = match.tl;
      if (match$1 !== 0 && match$1.tl !== 0) {
        return JsxRuntime.jsx(Router$NotFound, {});
      } else {
        return JsxRuntime.jsx(ProtectedRoute.ProtectedRoute.make, {
          children: JsxRuntime.jsx(JournalPage.make, {})
        });
      }
    case "login" :
      if (match.tl !== 0) {
        return JsxRuntime.jsx(Router$NotFound, {});
      } else {
        return JsxRuntime.jsx(LoginPage.make, {});
      }
    case "posts" :
      let match$2 = match.tl;
      if (match$2 !== 0) {
        if (match$2.tl !== 0) {
          return JsxRuntime.jsx(Router$NotFound, {});
        } else {
          return JsxRuntime.jsx(PostPage.make, {
            id: match$2.hd
          });
        }
      } else {
        return JsxRuntime.jsx(PostsPage.make, {});
      }
    default:
      return JsxRuntime.jsx(Router$NotFound, {});
  }
}

let make = Router;

export {
  NotFound,
  make,
}
/* Theme Not a pure module */
